export function ShowOrganizationSelf(organizationID: number): string {
	return `/v1/organizations/${organizationID}/self`;
}

export function ShowSelf(): string {
	return `/v1/self`;
}

